<template>
    <div>
        <div class="pws-content">
            <div class="row">
                <div class="col-12 col-lg-6 pws-left-content">
                    <div class="apprentice-simple-card description">
                        {{
                            $t(
                                'paper.here_you_will_find_all_kind_of_information_and_resources_that_can_help_you_create_your_profile_paper_if_you_have_a_good_tip_please_let_us_know',
                            )
                        }}
                    </div>

                    <div class="apprentice-simple-card pws-explanation-videos">
                        <div class="component-title">
                            <h5 class="title">{{ $t('paper.videos') }}</h5>
                        </div>
                        <div class="row">
                            <div class="col-12 col-sm-6 col-xl-6 pws-card-wrapper">
                                <div
                                    class="apprentice-simple-card pws-card pws-video-card"
                                    @click="playVideo('40G9xAwJIsQ', $t('paper.profile_paper_choose_subject'))">
                                    <img
                                        class="pws-header"
                                        src="/images/pws/slide1-banner.jpg"
                                        :alt="$t('paper.make_profile_paper_choose_subject')" />
                                    <div class="description">
                                        <h5 class="title">{{ $t('paper.choose_subject') }}</h5>
                                        <p class="type btn-youtube-icon">{{ $t('paper.digital_studies') }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-6 pws-card-wrapper">
                                <div
                                    class="apprentice-simple-card pws-card pws-video-card"
                                    @click="playVideo('kDeo4h3W0JQ', $t('paper.profile_paper_construction'))">
                                    <img
                                        class="pws-header"
                                        src="/images/pws/slide2-banner.jpg"
                                        :alt="$t('paper.make_profile_paper_construction')" />
                                    <div class="description">
                                        <h5 class="title">{{ $t('paper.profile_paper_construction') }}</h5>
                                        <p class="type btn-youtube-icon">{{ $t('paper.digital_studies') }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-6 pws-card-wrapper">
                                <div
                                    class="apprentice-simple-card pws-card pws-video-card"
                                    @click="playVideo('KNNPlDuWaMI', $t('paper.profile_paper_do_research'))">
                                    <img
                                        class="pws-header"
                                        src="/images/pws/slide3-banner.jpg"
                                        :alt="$t('paper.make_profile_paper_do_research')" />
                                    <div class="description">
                                        <h5 class="title">{{ $t('paper.do_research') }}</h5>
                                        <p class="type btn-youtube-icon">{{ $t('paper.digital_studies') }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-6 pws-card-wrapper">
                                <div
                                    class="apprentice-simple-card pws-card pws-video-card"
                                    @click="playVideo('8cUC_VZ4-0c', $t('paper.profile_paper_refer_sources'))">
                                    <img
                                        class="pws-header"
                                        src="/images/pws/slide4-banner.jpg"
                                        :alt="$t('paper.make_profile_paper_refer_sources')" />
                                    <div class="description">
                                        <h5 class="title">{{ $t('paper.refer_sources') }}</h5>
                                        <p class="type btn-youtube-icon">{{ $t('paper.digital_studies') }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <design-2021-profile-paper-index-video-modal-components
                            ref="pws-video-modal"></design-2021-profile-paper-index-video-modal-components>
                    </div>
                    <div class="apprentice-simple-card pws-prices">
                        <div class="component-title">
                            <h5 class="title">{{ $t('paper.win_a_prize_with_your_profile_paper') }}</h5>
                        </div>

                        <div class="pws-price-media">
                            <div class="pws-price-icon">
                                <div class="wrapper">
                                    <i class="fad fa-trophy"></i>
                                </div>
                            </div>
                            <div class="pws-price-body">
                                <div class="title">KNAW</div>
                            </div>
                            <a
                                class="clickable"
                                href="https://www.knawonderwijsprijs.nl/"
                                target="_blank"></a>
                        </div>
                        <div class="pws-price-media">
                            <div class="pws-price-icon">
                                <div class="wrapper">
                                    <i class="fad fa-trophy"></i>
                                </div>
                            </div>
                            <div class="pws-price-body">
                                <div class="title">Rijksmuseum</div>
                            </div>
                            <a
                                class="clickable"
                                href="https://www.rijksmuseum.nl/nl/onderwijs/voortgezet-onderwijs/havo-vwo/talentprogrammas/junior-fellowship"
                                target="_blank"></a>
                        </div>
                        <div class="pws-price-media">
                            <div class="pws-price-icon">
                                <div class="wrapper">
                                    <i class="fad fa-trophy"></i>
                                </div>
                            </div>
                            <div class="pws-price-body">
                                <div class="title">NVLM</div>
                            </div>
                            <a
                                class="clickable"
                                href="https://www.nvlm.nl/nvlm/activiteiten/wedstrijd/"
                                target="_blank"></a>
                        </div>
                        <div class="pws-price-media">
                            <div class="pws-price-icon">
                                <div class="wrapper">
                                    <i class="fad fa-trophy"></i>
                                </div>
                            </div>
                            <div class="pws-price-body">
                                <div class="title">Radboud Universiteit - Melsen prijs</div>
                            </div>
                            <a
                                class="clickable"
                                href="https://www.ru.nl/ise/outreach/pre-university-college-science/leerlingen/science-wedstrijden-olympiades-1/van-melsenprijs/"
                                target="_blank"></a>
                        </div>
                        <div class="pws-price-media">
                            <div class="pws-price-icon">
                                <div class="wrapper">
                                    <i class="fad fa-trophy"></i>
                                </div>
                            </div>
                            <div class="pws-price-body">
                                <div class="title">Radboud Universiteit - Nescioprijs</div>
                            </div>
                            <a
                                class="clickable"
                                href="https://www.ru.nl/pucsociety/scholieren/profielwerkstuk/nescioprijs-2022/"
                                target="_blank"></a>
                        </div>
                        <div class="pws-price-media">
                            <div class="pws-price-icon">
                                <div class="wrapper">
                                    <i class="fad fa-trophy"></i>
                                </div>
                            </div>
                            <div class="pws-price-body">
                                <div class="title">RU Groningen - Marie Lokeprijs</div>
                            </div>
                            <a
                                class="clickable"
                                href="https://www.rug.nl/education/scholierenacademie/scholieren/pws-hulp/profielwerkstuk-prijs"
                                target="_blank"></a>
                        </div>
                        <div class="pws-price-media">
                            <div class="pws-price-icon">
                                <div class="wrapper">
                                    <i class="fad fa-trophy"></i>
                                </div>
                            </div>
                            <div class="pws-price-body">
                                <div class="title">RU Groningen – Jan Kommandeurprijs</div>
                            </div>
                            <a
                                class="clickable"
                                href="http://www.rug.nl/sciencelinx/betasteunpunt/jankommandeurprijs/jankommandeurprijs"
                                target="_blank"></a>
                        </div>
                        <div class="pws-price-media">
                            <div class="pws-price-icon">
                                <div class="wrapper">
                                    <i class="fad fa-trophy"></i>
                                </div>
                            </div>
                            <div class="pws-price-body">
                                <div class="title">RU Groningen - Jan Penprijs</div>
                            </div>
                            <a
                                class="clickable"
                                href="https://www.rug.nl/education/scholierenacademie/scholieren/pws-hulp/profielwerkstuk-prijs"
                                target="_blank"></a>
                        </div>
                        <div class="pws-price-media">
                            <div class="pws-price-icon">
                                <div class="wrapper">
                                    <i class="fad fa-trophy"></i>
                                </div>
                            </div>
                            <div class="pws-price-body">
                                <div class="title">Universiteit Leiden</div>
                            </div>
                            <a
                                class="clickable"
                                href="https://www.universiteitleiden.nl/scholen/scholieren-en-wetenschap/profielwerkstuk"
                                target="_blank"></a>
                        </div>
                        <div class="pws-price-media">
                            <div class="pws-price-icon">
                                <div class="wrapper">
                                    <i class="fad fa-trophy"></i>
                                </div>
                            </div>
                            <div class="pws-price-body">
                                <div class="title">{{ $t('paper.teachers_of_living_languages') }}</div>
                            </div>
                            <a
                                class="clickable"
                                href="http://www.franszelfsprekend.nl/doe-mee/profielwerkstukkenwedstrijd-2"
                                target="_blank"></a>
                        </div>
                        <div class="pws-price-media">
                            <div class="pws-price-icon">
                                <div class="wrapper">
                                    <i class="fad fa-trophy"></i>
                                </div>
                            </div>
                            <div class="pws-price-body">
                                <div class="title">Stichting Imagine Life Sciences</div>
                            </div>
                            <a
                                class="clickable"
                                href="http://imaginationatwork.nl/wedstrijden/havovwo/"
                                target="_blank"></a>
                        </div>
                        <!--                       <div class="pws-price-media">-->
                        <!--                           <div class="pws-price-icon">-->
                        <!--                               <div class="wrapper">-->
                        <!--                                   <i class="fad fa-trophy"></i>-->
                        <!--                               </div>-->
                        <!--                           </div>-->
                        <!--                           <div class="pws-price-body">-->
                        <!--                               <div class="title">Rijkswaterstaat/ Wetsus</div>-->
                        <!--                           </div>-->
                        <!--                           <a href="https://platformwow.nl/thema-s/dutch-junior-water-prize/" target="_blank" class="clickable"></a>-->
                        <!--                       </div>-->
                        <div class="pws-price-media">
                            <div class="pws-price-icon">
                                <div class="wrapper">
                                    <i class="fad fa-trophy"></i>
                                </div>
                            </div>
                            <div class="pws-price-body">
                                <div class="title">Universiteit Utrecht</div>
                            </div>
                            <a
                                class="clickable"
                                href="https://www.uu.nl/onderwijs/scholennetwerk/profielwerkstukken"
                                target="_blank"></a>
                        </div>
                        <div class="pws-price-media">
                            <div class="pws-price-icon">
                                <div class="wrapper">
                                    <i class="fad fa-trophy"></i>
                                </div>
                            </div>
                            <div class="pws-price-body">
                                <div class="title">
                                    {{
                                        $t(
                                            'paper.neerlandistiek_online_magazine_for_linguistic_and_literary_research',
                                        )
                                    }}
                                </div>
                            </div>
                            <a
                                class="clickable"
                                href="https://www.neerlandistiek.nl/2019/11/profielwerkstukwedstrijd-levende-talen-2020/#more-43999"
                                target="_blank"></a>
                        </div>
                        <div class="pws-price-media">
                            <div class="pws-price-icon">
                                <div class="wrapper">
                                    <i class="fad fa-trophy"></i>
                                </div>
                            </div>
                            <div class="pws-price-body">
                                <div class="title">3i AWARD pws informatica</div>
                            </div>
                            <a
                                class="clickable"
                                href="https://3i-award.nl/"
                                target="_blank"></a>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-lg-6 pws-right-content">
                    <design-2021-profile-paper-index-source-component></design-2021-profile-paper-index-source-component>

                    <div class="apprentice-simple-card pws-links">
                        <div class="component-title">
                            <h5 class="title">{{ $t('paper.informative_websites') }}</h5>
                        </div>
                        <div class="row">
                            <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 pws-links-wrapper">
                                <div class="apprentice-simple-card pws-links-card">
                                    <div class="icon">
                                        <img
                                            src="/images/pws/brands/hogeschool-rotterdam-logo.png"
                                            alt="Hogeschool Rotterdam logo" />
                                    </div>
                                    <div class="content">
                                        <h5 class="title">
                                            {{ $t('paper.choose_subject') }}
                                        </h5>
                                        <div class="description">
                                            {{
                                                $t(
                                                    'paper.de_hogeschool_rotterdam_will_help_you_choose_a_subject',
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <a
                                        class="clickable"
                                        href="https://www.hogeschoolrotterdam.nl/voorlichting/begeleiding-en-voorzieningen/profielwerkstuk/onderwerp-kiezen/"
                                        target="_blank"></a>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 pws-links-wrapper">
                                <div class="apprentice-simple-card pws-links-card">
                                    <div class="icon">
                                        <img
                                            src="/images/pws/brands/Logo-Tilburg-University.png"
                                            alt="Tilburg University logo" />
                                    </div>
                                    <div class="content">
                                        <h5 class="title">
                                            {{ $t('paper.profile_paper_design') }}
                                        </h5>
                                        <div class="description">
                                            {{
                                                $t(
                                                    'paper.you_can_find_more_information_about_the_design_and_writing_of_your_profile_paper_on_the_tilburg_university_website',
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <a
                                        class="clickable"
                                        href="https://www.tilburguniversity.edu/nl/onderwijs/bacheloropleidingen/studiekeuze/profielwerkstuk/profielwerkstuk-schrijven"
                                        target="_blank"></a>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 pws-links-wrapper">
                                <div class="apprentice-simple-card pws-links-card">
                                    <div class="icon">
                                        <img
                                            src="/images/pws/brands/profielwerkstuk_nl.svg"
                                            alt="Profielwerkstuk.nl logo" />
                                    </div>
                                    <div class="content">
                                        <h5 class="title">Profielwerkstuk.nl</h5>
                                        <div class="description">
                                            {{
                                                $t(
                                                    'paper.helps_you_with_your_profile_paper_tips_and_tricks_for_creating_your_profile_paper',
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <a
                                        class="clickable"
                                        href="https://www.profielwerkstuk.nl/"
                                        target="_blank"></a>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-4 pws-links-wrapper">
                                <div class="apprentice-simple-card pws-links-card">
                                    <div class="icon">
                                        <img
                                            src="/images/pws/brands/radboud-university.png"
                                            alt="Radboud Universiteit logo" />
                                    </div>
                                    <div class="content">
                                        <h5 class="title">Radboud Universiteit</h5>
                                        <div class="description">
                                            {{
                                                $t(
                                                    'paper.at_radboud_university_you_can_find_a_lot_of_information_about_completing_your_profile_paper_and_you_can_ask_questions',
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <a
                                        class="clickable"
                                        href="https://www.ru.nl/pucsociety/scholieren/profielwerkstuk/"
                                        target="_blank"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-profile-paper-index-components',
    methods: {
        showPlaylistModal(videoId, videoTitle) {
            const title = 'pws-video-modal';
            this.$refs[title].show(videoId, videoTitle);
        },

        playVideo(videoId, videoTitle) {
            const name = 'pws-video-modal';
            this.$refs[name].show(videoId, videoTitle);
        },
    },
};
</script>

<style scoped lang="scss">
.pws-content {
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
}

.pws-left-content {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.pws-card-wrapper,
.pws-price-wrapper {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.pws-card {
    height: 100%;
    transition: all 0.3s ease;
    padding: 0;
    border: solid 1px transparent;

    .pws-header {
        width: 100%;
        height: 125px;
        object-fit: cover;
        object-position: center;
    }

    .description {
        padding: map-get($grid-gutter-spacing, 'fifteen');

        .title {
            margin-bottom: map-get($grid-gutter-spacing, 'five');
        }

        .type,
        .source {
            line-height: 1.3;
            font-weight: $font-weight-medium;
        }

        .type {
            justify-content: flex-start;
            color: $text-muted-color;
            margin-bottom: 0;
        }

        .source {
            margin-bottom: map-get($grid-gutter-spacing, 'eight');
            line-height: 1.3;
        }
    }

    &:hover {
        border: solid 1px $border-color;
        cursor: pointer;
        box-shadow:
            0 3px 21px 0 rgb(0 0 0 / 10%),
            0 1px 8px 0 rgb(0 0 0 / 5%);
    }
}

.pws-video-card {
    .type {
        &:before {
            color: $danger;
        }
    }
}

.pws-links {
    .pws-links-wrapper {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }
}

.pws-links-card {
    background-color: $secondary-background-color;
    position: relative;
    height: 100%;
    transition: all 0.3s ease;
    border: solid 1px transparent;

    .icon {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 150px;

        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

        img {
            width: 100%;
            height: 100%;
            object-position: center;
            object-fit: contain;
        }

        i {
            font-size: 6rem;
            color: $primary;
        }
    }

    .brand {
        height: 30px;
    }

    &:hover {
        border: solid 1px $border-color;
        cursor: pointer;
        box-shadow:
            0 3px 21px 0 rgb(0 0 0 / 10%),
            0 1px 8px 0 rgb(0 0 0 / 5%);
    }
}

.pws-price-media {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    background: $secondary-background-color;
    border-radius: 12px;
    width: 100%;
    margin-right: 0;
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

    &:hover {
        box-shadow:
            0 3px 21px 0 rgb(0 0 0 / 10%),
            0 1px 8px 0 rgb(0 0 0 / 5%);
        cursor: pointer;
        transform: scale(1.01);
        transform-origin: center;
    }
}

.pws-price-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5625rem;
    color: $secondary-background-color;

    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #3eafc5;
        padding: map-get($grid-gutter-spacing, 'twenty-one');
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        width: 36px;
        height: 36px;
    }
}

.pws-price-body {
    padding: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen');
    font-weight: $font-weight-bold;
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .pws-links-card {
        .icon {
            height: 185px;
        }
    }

    .pws-price-media {
        width: fit-content;
        margin-right: map-get($grid-gutter-spacing, 'fifteen');
    }
}

@media (min-width: map-get($grid-breakpoints, 'xxl')) {
    .pws-prices {
        height: 520px;
    }
}
</style>
